















































import Vue from "vue";
import { RoomDetail } from "@/models/room";
import RoomLastCommands from "@/components/dashboard/rooms/room/RoomLastCommands.vue";
import LoggingAndroid from "@/components/dashboard/rooms/room/LoggingAndroid.vue";
import PoliciesChooser from "../policies/PoliciesChooser.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import VaTextField from "@/components/atoms/VaTextField.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import RoomService from "@/services/roomService";
import { RoomCommandTypes } from "@/models/room";

export default Vue.extend({
  name: "RoomRemoteManagementAndroid",
  components: {
    RoomLastCommands,
    LoggingAndroid,
    PoliciesChooser,
    VaCard,
    VaTextField,
    VaButton,
  },
  props: {
    roomId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // error: "",
      // updateRequiredDialog: false
    };
  },
  computed: {
    room(): RoomDetail {
      return this.$store.getters["room/room"];
    },
    isAndroid(): boolean {
      return this.room?.deviceType === "AndroidReceiver";
    },
  },
  methods: {
    async setName(): Promise<void> {
      try {
        await RoomService.sendCommand(
          RoomCommandTypes.MACHINE_NAME,
          this.room.name
        );
        this.$store.commit("notifications/displayNotification", {
          message: this.$t("roomCommands.commandSuccess"),
          type: "success",
        });
      } catch (e) {
        this.$store.commit("notifications/displayNotification", {
          message: e,
          type: "error",
        });
        this.$sentry.capture(e, "RoomRemoteManagement", "sendCommand");
      }
    },
  },
});
